import type { ComponentLoaderType } from '@grafikr/components';

const Loader: ComponentLoaderType = ({ node }, load) => {
  const url = new URL(window.location.href);

  if (url.searchParams.get(node.dataset.loadParam) !== null) {
    load();
  }

  return () => {};
};

export default Loader;
